import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { setMinPercTasks as setMinPercTasksDiagram, reloadASAData} from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = ApiMethodBase & {
    min: number;
};

export const setMinPercTasks = ({
    min,
}: Props) => {
    setMinPercTasksDiagram({min});
    reloadASAData()

};



